var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 44C0 19.6995 19.6995 0 44 0C68.3005 0 88 19.6995 88 44C88 68.3005 68.3005 88 44 88C19.6995 88 0 68.3005 0 44Z",
    fill: "#E1292B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2083_47757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7432 33.5235C49.9498 31.9368 47.3598 31.9368 46.5665 33.5235L39.3332 48.0135L36.7432 42.8568C36.3465 42.0635 35.5532 41.5735 34.6665 41.5735H20.6665V46.2402H33.2198L37.2332 54.2902C37.6532 55.0835 38.4465 55.5735 39.3332 55.5735C40.2198 55.5735 41.0132 55.0835 41.4098 54.2902L48.6665 39.8002L51.2565 44.9568C51.6532 45.7502 52.4465 46.2402 53.3332 46.2402H67.3332V41.5735H54.7798L50.7432 33.5235Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2083_47757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/stress.8c3e7873daa01d39dbf0f4fc29dbde91.svg";
export { ForwardRef as ReactComponent };